import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingChatPopupContainer } from './NewbuildingChatPopupContainer';
import { OfferChatPopupContainer } from './OfferChatPopupContainer';
import { selectChat } from '../../selectors/selectChat';

export const ChatPopupContainer: React.FC = () => {
  const { newbuildingContact } = useSelector(selectChat);

  return newbuildingContact ? <NewbuildingChatPopupContainer /> : <OfferChatPopupContainer />;
};
